import { Card, Layout, Spin, Typography } from "antd"
import { useTranslation } from "react-i18next"

import LoginHeader from "../../Components/LoginHeader"
import {
  RecoveryCodesBlock,
  ScanCodeBlock,
  TwoFactorSuccessModal
} from "../../Components/TwoFactor"
import { useAdminTwoFactorSetupPage } from "./hooks/useAdminTwoFactorSetupPage"

import "./styles.less"

const { Text } = Typography

function AdminTwoFactorSetupPage() {
  const { t } = useTranslation()
  const {
    fetching,
    isSuccessModalOpen,
    isQrStep,
    isRecoveryStep,
    twoFactorQrCode,
    twoFactorRecoveryCodes,
    twoFactorSecret,
    verificationError,
    handleCancelRecoveryCodes,
    handleConfirmSetup,
    handleFinishSetup,
    handleRecoveryCodesSaved
  } = useAdminTwoFactorSetupPage()

  return (
    <Layout>
      <Spin size="large" spinning={fetching}>
        <div className="login-row">
          <LoginHeader withLogout />
          <div className="login-content">
            <div className="content-main sign-up">
              <Card className="login-card admin-2fa-setup-card">
                <Text strong>{t("Two-factor authentication")}</Text>
                <Text type="secondary">
                  {t(
                    "Authenticator apps (like Google Authenticator) generate one-time codes used to verify your sign-in."
                  )}
                </Text>
                {isQrStep && (
                  <ScanCodeBlock
                    t={t}
                    qrCodeSrc={twoFactorQrCode}
                    setupKey={twoFactorSecret}
                    isQrCentered
                    isSaveButtonBlock
                    hasSaveButtonTopMargin
                    buttonText="Save"
                    otpError={verificationError}
                    isSubmitting={fetching}
                    onSubmit={handleConfirmSetup}
                  />
                )}
                {isRecoveryStep && (
                  <RecoveryCodesBlock
                    t={t}
                    onSuccess={handleRecoveryCodesSaved}
                    onCancel={handleCancelRecoveryCodes}
                    isSetupMode
                    isSubmitting={fetching}
                    recoveryCodes={twoFactorRecoveryCodes}
                    requireDownloadBeforeContinue
                  />
                )}
              </Card>
            </div>
          </div>
        </div>
      </Spin>
      <TwoFactorSuccessModal
        open={isSuccessModalOpen}
        onClose={handleFinishSetup}
        onSuccess={handleFinishSetup}
        buttonText="Go to Alerts"
        closable
        maskClosable={false}
        t={t}
      />
    </Layout>
  )
}

export default AdminTwoFactorSetupPage
